export default "__VITE_ASSET__DLhDdqyt__"